export default "__VITE_ASSET__CO$sHGpj__"